import { useLocation } from '@reach/router';
import classnames from 'classnames';
import { navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';
import './TabsHeader.scss';
import useWindowSize from '../../hooks/useWindowSize';
import { Swiper, SwiperSlide } from 'swiper/react';

interface TabsProps {
  tabs: Array<Tab>;
  activeTab: string;
}

interface Tab {
  title: string;
  description?: string;
  url: string;
  children?: React.ReactElement;
}

export function TabsHeader({ tabs, activeTab }: TabsProps): React.ReactElement {
  const [selectedTab, setSelectedTab] = useState<string>(activeTab);
  const location = useLocation();

  const { width } = useWindowSize();
  useEffect(() => {
    if (location.hash) {
      tabs.forEach((tab, index) => {
        if (tab.url === location.hash.substring(1)) {
          setSelectedTab(tabs[index].title);
        }
      });
    } else setSelectedTab(tabs[0].title);
  }, [tabs, location]);

  return (
    <div className="tabs">
      {!width || width >= 1000 ? (
        <div className="tabs__header">
          {tabs.map((tab) => {
            if (tab.children === null) return null;
            return (
              <div
                className="tabs__item"
                key={tab.title}
                onClick={() => {
                  navigate('#' + tab.url);
                }}
              >
                <button className={classnames({ 'tabs__item--selected': tab.title === selectedTab })} onClick={() => setSelectedTab(tab.title)}>
                  {tab.title}
                </button>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="tabs__header">
          <Swiper
            spaceBetween={0}
            initialSlide={0}
            slidesPerView={2.5}
            grabCursor={true}
            watchOverflow={true}
            centeredSlides={false}
            direction={'horizontal'}
            loop={false}
            className="tabs__header--swiper"
          >
            {tabs.map((tab) => {
              if (tab.children === null) return null;
              return (
                <SwiperSlide key={tab.title}>
                  <div
                    className="tabs__item"
                    onClick={() => {
                      navigate('#' + tab.url);
                    }}
                  >
                    <button className={classnames({ 'tabs__item--selected': tab.title === selectedTab })} onClick={() => setSelectedTab(tab.title)}>
                      {tab.title}
                    </button>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
      <div className="tabs__content">
        {tabs
          .filter((tab) => tab.title === selectedTab)
          .map((tab) => {
            return (
              <div key={tab.title} className="tabs__box">
                {tab.description && <p className="tabs__description">{tab.description}</p>}
                {tab.children}
              </div>
            );
          })}
      </div>
    </div>
  );
}
